"use client";

import { BarChart, BarChartData, BarChartInfo } from "ui/analysis/bar-chart";

type Props = {
  data: BarChartData[];
  info: BarChartInfo;
};

export const ClientChart = ({ data, info }: Props) => (
  <div className="h-64 w-full [&_.recharts-wrapper_.recharts-cartesian-grid-horizontal_line:last-child]:hidden">
    <BarChart
      data={data}
      info={info}
      yAxisWidth={40}
      yTicksFormatter={(value) => `${value ?? ""} %`}
      showLegend
      biAxial="ltr"
      tooltipIconType="circle"
      yPaddingTop={16}
      xAxisInterval={0}
      legendProps={{
        formatter: (value) => <span className="text-zinc-500">{value}</span>,
      }}
    />
  </div>
);
